import NoTableResults from '@shared/components/tables/table-components/no-table-results';
import { html } from '@shared/utils/rendering/html';

export const MissingPermissionsCard = ({ message, ...props }) => {
    const errorMessage =
        message || props?.isAuthenticated
            ? 'The capturer for this entity has not initiated the assessment for this period.'
            : 'Please sign in to access this resource';

    return html` <${NoTableResults} message=${{ text: errorMessage }} /> `;
};
